
export const api_base = 'http://localhost:1337'

export const grapql_url = api_base + '/graphql'



// WEBPACK FOOTER //
// ./src/constants/app.js